import { MIXED } from "../constants/DesignConstants.mjs";
import { isSyncMixed, isPropValueMixed } from "./InheritanceUtils";

export const setupHandleWheel =
  ({ shiftMod = 10, step = 1, min } = { shiftMod: 10, step: 1 }, cb, value) =>
  (e) => {
    const { altKey, deltaX, detail, shiftKey, target, wheelDelta } = e;
    if (target === document.activeElement) {
      e.stopPropagation && e.stopPropagation();
      e.preventDefault && e.preventDefault();
      // remove this once we are past react 16
      e.persist && e.persist();

      const delta = wheelDelta ?? deltaX ?? detail;
      const clampedDelta = Math.max(-1, Math.min(1, -delta));

      const ALT_MOD = 100;
      const modDelta = (shiftKey ? shiftMod : altKey ? ALT_MOD : 1) * clampedDelta;

      let newValue = parseFloat(value) + modDelta * (step * -1);
      newValue = Math.round(newValue * 100) / 100;
      if (min !== undefined && newValue < min) {
        newValue = min;
      }

      cb(newValue, e);
    }
  };

export const prepareInputUtils = (layout, preparedElement, gatheredProps) => {
  const isMixed = (propName) =>
    isPropValueMixed(propName, layout, preparedElement) || isSyncMixed(propName, preparedElement);

  const getWithoutLayout = (propName, fallbackValue) =>
    preparedElement.getIn(propName.split("."), fallbackValue);

  const prepareValue = (propName, fallbackValue) =>
    isSyncMixed(propName, preparedElement)
      ? MIXED
      : layout === undefined
      ? getWithoutLayout(propName, fallbackValue)
      : gatheredProps.getIn(propName.split("."), fallbackValue);

  const canMerge = (propName) => !isMixed(propName);

  return {
    canMerge,
    isMixed,
    isSyncMixed: (propName) => isSyncMixed(propName, preparedElement),
    prepareValue,
  };
};
